/* src/app/reports-view/ship-reports/ship-reports.component.css */
.spinner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
  width: 75%;
}
/*# sourceMappingURL=ship-reports.component.css.map */
